import dispatch from './dispatch';
import dispatchSessionError from './dispatchSessionError';

const actions = { dispatch, dispatchSessionError };

export default actions;
